import { Observable } from 'rxjs';
import { CacheService } from './cache.service';
import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { GOODWILL_CONSTANT } from './../utils/constant';
import { AppConfig } from '../app.config';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  domain: string;
  istokenreceived: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(
    private httpService: HttpService,
    private apiconfig :AppConfig,
    private cacheService: CacheService
    ) {

      var apipath='';
        if(this.apiconfig.mpsaFlag==='N'){
          apipath = location.protocol + '//' + this.apiconfig.apiUrl;
        }

      this.domain = apipath+this.apiconfig.apiPath;
     }

  public authenticateToken(token: string): Observable<any> {
    const finalUrl = this.domain + GOODWILL_CONSTANT.AUTHENTICATE_TOKEN;
    let result: Observable<any>;
    result = this.httpService.getCallForToken(finalUrl, token);
     result.subscribe(response=> {
      console.log(123);
      console.log('response from subscription: ', response);
    }) 
    return result;
  }

  // Method to call a API for validating a token
  public validateToken(token: string) {
      const finalUrl = this.domain+ GOODWILL_CONSTANT.VALIDATE_TOKEN;
      return this.httpService.getCallForToken(finalUrl, token);
  }


}
